import {
  BASE_PATH_TO_COUNTRY_NAME_MAP,
  GAMING_ROLLOUT_COOKIE_NAME,
  VERTICALS_FOR_SIMPLIFIED_ROLLOUT_TRACKING,
  VERTICALS_WITH_ROLLOUT_ENABLED,
} from '@/logic/main/constants';
import {
  trackGamingRolloutVisit,
  trackSimpleGamingRolloutVisit,
} from '@/model/tracking';
import Cookie from '@/ports-frontend/Cookie';
import { AvailableBasePathTypes } from '@/types/common';
import { startCase } from '@/utils/lodash-alternatives';

interface ScopeType {
  scope: {
    locale: AvailableBasePathTypes;
    group: 'control' | 'variant';
    date: string;
    split: number;
    vertical: 'games' | 'live-casino' | 'casino';
  };
}

export const trackGamingRollout = async () => {
  const data = await Cookie.get(GAMING_ROLLOUT_COOKIE_NAME);
  if (data) {
    try {
      const { scope }: ScopeType = JSON.parse(data);
      const verticalName = startCase(scope.vertical).replace(' ', '');
      const isControlGroup = scope.group === 'control';

      // Remove rollout cookie for outdated rollouts to not track them anymore
      if (
        !VERTICALS_WITH_ROLLOUT_ENABLED.includes(verticalName.toLowerCase())
      ) {
        return await Cookie.remove(GAMING_ROLLOUT_COOKIE_NAME);
      }

      if (VERTICALS_FOR_SIMPLIFIED_ROLLOUT_TRACKING.includes(verticalName)) {
        const payload = {
          split: scope.split,
          verticalName,
          segmentType: isControlGroup ? 'Control' : 'Variant',
        };
        return trackSimpleGamingRolloutVisit(payload);
      }

      const countryName = scope.locale
        ? BASE_PATH_TO_COUNTRY_NAME_MAP[scope.locale]
        : '';
      const countryNamePrefix =
        scope.locale === 'en-gb' ? 'UK' : `ROW_${countryName}`;

      const payload = {
        date: scope.date,
        split: scope.split,
        countryNamePrefix,
        verticalName,
        segmentType: isControlGroup ? 'Control' : 'Variant',
      };

      trackGamingRolloutVisit(payload);
    } catch (e) {
      console.error(`Incorrect '${GAMING_ROLLOUT_COOKIE_NAME}' cookie data.`);
    }
  }
};
